const getters = {
  acctLoaded: state => state.acctLoaded,
  isAdmin: state => state.isAdmin,
  routers: state => state.routers,
  routerLoaded: state => state.routerLoaded,
  progress: state => state.progress,
  currentTitle: state => state.currentTitle,
  acctName: state => state.acctName

}
export default getters
